import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserSettingsStore } from '../../../../state/user-settings.repository';
import { AppService } from '../../../../core/services/app.service';
import { AppStore } from '../../../../state/app.repository';
import { AppConfigStore } from '../../../../state/app-config.repository';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TextField } from '../../../../shared/components/form-fields/text-field/text-field';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatToggleWrapper } from '../../../../shared/components/material-wrappers/mat-toggle-wrapper/mat-toggle-wrapper';
import { faServer, faShieldKeyhole } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'andor-settings-developer',
  imports: [
    FontAwesomeModule,
    ReactiveFormsModule,
    TextField,
    TranslatePipe,
    MatSlideToggle,
    MatToggleWrapper,
  ],
  templateUrl: './settings-developer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './settings-developer.scss',
})
export class SettingsDeveloper {
  protected readonly faServer = faServer;
  protected readonly faShieldKeyhole = faShieldKeyhole;

  // Both fields are optional overrides: empty means "use the app defaults",
  // so neither control is required.
  devFormGroup = new FormGroup({
    gateway: new FormControl(''),
    accessKey: new FormControl(''),
  });
  isSFUConnection = signal(false);

  // Shown as the gateway field's placeholder so an empty field still tells
  // the user which address will be used. Never patched into the control —
  // otherwise it would be persisted as a custom override on the next form
  // change and the field could never stay cleared.
  protected readonly defaultGateway: string;

  constructor(
    public userSettingsStore: UserSettingsStore,
    public appService: AppService,
    public appStore: AppStore,
    public appConfig: AppConfigStore
  ) {
    this.defaultGateway = appConfig.saved().gateway;
    this.devFormGroup.patchValue({
      gateway: userSettingsStore.value.serverAddress,
      accessKey: userSettingsStore.value.accessKey,
    });
    this.isSFUConnection.set(userSettingsStore.value.isSFUConnection);
    this.devFormGroup.valueChanges.subscribe((changes) => {
      this.userSettingsStore.update({
        serverAddress: changes.gateway?.trim() ?? '',
        accessKey: changes.accessKey?.trim() ?? '',
      });
    });
  }

  toggleSFUConnection() {
    this.userSettingsStore.store.update((state) => ({
      ...state,
      isSFUConnection: !state.isSFUConnection,
    }));
  }
}
